import { Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Voucher } from 'app/models/vouchers/voucher';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { VoucherService } from 'app/services/voucher-service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';
import { HouseholdService } from 'app/services/household-service';
import { HouseholdLetterUpload } from 'app/models/household/household-letter-upload';
import { IHousehold } from 'app/models/household/household';

@Component({
  selector: 'coc-household-letter',
  templateUrl: './coc-household-letter.component.html',
  styleUrls: ['./coc-household-letter.component.scss']
})
export class COCHouseholdLetterComponent implements  OnInit {
  public environment = environment;
  voucher: Voucher = undefined;
  household: IHousehold = undefined;
  processing: boolean = false;
  processingMessage: string = "";
  mailingAddress: string = "";
  mailingCity: string = "";
  mailingState: string = "";
  mailingZip: string = "";
  today: string = "";
  letter: HouseholdLetterUpload = {
    id: 0,
    letterHtml: '',
    letterType: this.householdService.householdCOCLetterType,
    parameterResultId: 0,
    sampleId: 0,
    letterContent: '',
    householdId: 0,
    base64File: ''
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: HouseholdLetterUpload,
              private dialogRef: MatDialogRef<COCHouseholdLetterComponent>,
              public voucherService: VoucherService, 
              public householdService: HouseholdService,
              private toastr: ToastrService, 
              public oregonWellDataService: OregonWellDataService) {                
                this.letter = this.data;
  }


  ngOnInit(): void {
    this.today = new Date().toLocaleString('default', { month: 'long' }) + " " + (new Date().getDate()).toString() + ", " + (new Date().getFullYear()).toString();
    this.loadHousehold();
  }

  loadHousehold() {
    this.processing = true;
    this.processingMessage = "Generating";
    this.householdService.getHouseholdById(this.letter.householdId).subscribe(
      result => {
        this.household = result;
        this.processing = false;
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
        this.toastr.error("Unable to load household");
      }
    );
  }

  onSubmit() {
    this.letter.letterHtml = this.oregonWellDataService.stripHtmlComments(document.getElementById('householdLetterPdf').innerHTML);

    this.processing = true;
    this.processingMessage = "Saving Letter";
    this.householdService.uploadLetter(this.letter).subscribe(
      result => {
        this.processingMessage = "";
        this.processing = false;
        this.toastr.success("Household Chain of Custody Letter saved");
        this.dialogRef.close();
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
      }
    );
  }

  onSubmitKendo() {
  }
}